module.exports = "/assets/c5a8ae3dd50e6ebe17044593c2c7ee0c.svg";